import { useCallback, useMemo } from 'react'

import { NumberInput, Select } from 'govwell-ui'
import { SelectOption } from 'govwell-ui/components/Select/types'
import { runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { ViewFilterNumberComparison } from 'types/graphql'

import {
  getLabelForNumberFilterComparison,
  NumberFilterComparisonOptions,
} from 'src/components/TableViews/util'
import { TableViewFilter } from 'src/models/TableViews/TableViewFilter'

type Props = {
  filter: TableViewFilter
}

const numberFilterOptions: SelectOption<ViewFilterNumberComparison>[] =
  NumberFilterComparisonOptions.map((comparison) => ({
    label: getLabelForNumberFilterComparison(comparison),
    value: comparison,
  }))

const NumberFilter = ({ filter }: Props) => {
  const format = filter.numberFormat

  const selectedOption = useMemo(
    () => numberFilterOptions.find((option) => option.value === filter.numberComparison),
    [filter.numberComparison]
  )

  const onComparisonChange = useCallback(
    (option: SelectOption<ViewFilterNumberComparison> | undefined) => {
      runInAction(() => {
        filter.numberComparison = option?.value
      })
    },
    [filter]
  )

  const onNumberChange = useCallback(
    (value: number | undefined) => {
      runInAction(() => {
        filter.number = value
      })
    },
    [filter]
  )

  return (
    <>
      <Select
        ariaLabel="Number filter"
        options={numberFilterOptions}
        selectedOption={selectedOption}
        getOptionKey={(option) => option.value}
        onSelectedOptionChange={onComparisonChange}
      />
      <NumberInput
        ariaLabel="Number filter"
        format={format}
        onValueChange={onNumberChange}
        value={filter.number}
      />
    </>
  )
}

export default observer(NumberFilter)
